import React, { Component } from "react";
import { DatePicker, Input } from "antd";
import moment, { relativeTimeRounding } from "moment";
import Widget from './Widget';
import dayjs from 'dayjs';

import '../css/widget/widget.poaition.date.css';

class WidgetPositionDate extends Component 
{
    constructor(props)
    {
        super(props);
        
        let divId = props.divId;
        if( !divId ) divId = Widget.randomString();

        this.state = {
            divId,
            options: props.options || {},
            dateFormat: props.dateFormat || 'YYYY-MM-DD',
            onChange: props.onChange || undefined,
            defaultValue:   props.defaultValue || []
        }

        // 获取组件自身
        this.myEndRef = React.createRef();
    }

    componentDidMount (){
        const {defaultValue} =this.state;
        if(defaultValue && defaultValue.length == 1){
            this.hithertoDate()
        }
    }

    handleChange = (value, type, valueType) => {
        
        let {dateFormat, defaultValue=[]} = this.state;
        let vals = [], message, show=false;
       
        if( type)
        {       
            if( valueType==="start")
            {
                if( value ){
                    defaultValue[0] = dayjs(value).format(dateFormat);
                }else
                {
                    defaultValue[0] =undefined
                }

               
                if(defaultValue[0]  )
                {
                    message = undefined;
                    show = false;
                }
              
                this.setState({ defaultValue:defaultValue, message:message, show:show,});


                if( this.props.onChange )
                {
                    this.props.onChange(defaultValue);
                }
            }
            else if( valueType==="end" )
            {

                if( value ){
                    defaultValue[1] = dayjs(value).format(dateFormat);
                }else
                {
                    defaultValue[1] =undefined
                } 

                this.setState({defaultValue:defaultValue, showInput:false, inputValue:undefined, showInput:false});

                if( !defaultValue[0] )
                {
                    message = '开始日期不能为空';
                    show = true;

                    this.setState({message:message, show:show});

                    return ;
                }

                if( this.props.onChange )
                {
                    this.props.onChange(defaultValue);
                }
            }
        }
        else
        {
            defaultValue = value && [dayjs(value).format(dateFormat)] || []

            if( this.props.onChange )
            {
                this.props.onChange(defaultValue);
            }

            this.setState({ defaultValue:defaultValue});
        }
     
    }

    disabledDate = ( currentDate, valueType ) => {

        const { defaultValue=[], options={}, dateFormat } = this.state;

        const { maxDate, minDate } = this.props;

        let ret = false;

        if( options.type )
        {
           

            if( valueType==="start")
            {
                if( maxDate )
                {
                    if( dayjs( Widget.dateFormatter(currentDate, dateFormat)).isAfter(dayjs(maxDate)) )
                    {
                        ret = true
                    }  
                }

                if( minDate && !ret )
                {
                    if( dayjs( Widget.dateFormatter(currentDate, dateFormat)).isBefore(dayjs(minDate)) )
                    {
                        ret = true
                    } 
                }

                if( defaultValue[1] && !ret )
                {
                    if( dayjs( Widget.dateFormatter(currentDate, dateFormat)).isAfter(dayjs(defaultValue[1])) )
                    {
                        ret = true
                    } 
                }
            }
            else 
            {
                if( maxDate )
                {
                    if( dayjs( Widget.dateFormatter(currentDate, dateFormat)).isAfter(dayjs(maxDate)) )
                    {
                        ret = true
                    }  
                }

                if( minDate && !ret )
                {
                    if( dayjs( Widget.dateFormatter(currentDate, dateFormat)).isBefore(dayjs(minDate)) )
                    {
                        ret = true
                    } 
                }

                if( defaultValue[0] && !ret )
                {
                    if( dayjs( Widget.dateFormatter(currentDate, dateFormat)).isBefore(dayjs(defaultValue[0])) )
                    {
                        ret = true
                    } 
                }
            }
        }

        return ret;

    }

    hithertoDate = () => {

        let { defaultValue=[], message, show=false } = this.state;

        defaultValue[1] = undefined;

        this.setState({defaultValue:defaultValue, showInput:true, inputValue:"至今", open:false});

        if( this.myEndRef && this.myEndRef.current )
        {
            this.myEndRef.current.blur();
        }

        if( !defaultValue[0] )
        {
            message = '开始日期不能为空';
            show = true;

            this.setState({message:message, show:show});

            return ;
        }

        if( this.props.onChange )
        {
            this.props.onChange(defaultValue);
        }

       
    }

    closeInput = () => {

        this.setState({open:true}); 
    }

    componentWillReceiveProps(nextProps)
    {
        
        this.setState({defaultValue:nextProps.defaultValue})
    }

    render()
    {
        const {options, dateFormat, divId, show=false, message, defaultValue=[], showInput=false, inputValue, open} = this.state;
        let { allowClear=true, picker='date' , width='150px', maxDate, minDate, disabled} = this.props;
      
        maxDate = maxDate ? dayjs(maxDate, dateFormat) : undefined;
        return <div className="sf-position-date-picker sm-position-date-picker sg-position-date-picker">
            {
                options.type ? 
                    <div id={divId}>
                        <div className="sf-date-picker-body sm-date-picker-body sg-date-picker-body">
                         <DatePicker
                            getPopupContainer={()=>document.getElementById(divId)}
                            allowClear={allowClear}
                            value={defaultValue[0] && dayjs(defaultValue[0], dateFormat)}
                            format={dateFormat}
                            picker={picker}
                            showToday={false}
                            style={{width}}
                            disabled={disabled}
                            disabledDate={( currentDate ) =>{ return this.disabledDate(currentDate, "start") }}
                            
                            onChange={(value)=>{this.handleChange(value, options.type, "start")}}
                        />

                        <span className="sf-date-split">至</span>

                        <DatePicker
                            ref={this.myEndRef}
                            getPopupContainer={()=>document.getElementById(divId)}
                            allowClear={allowClear}
                            value={defaultValue[1] && dayjs(defaultValue[1], dateFormat)}
                            format={dateFormat}
                            picker={picker}
                            showToday={false}
                            open={open}
                            disabled={disabled}
                            onOpenChange={(open) => {this.setState({open:open})}}
                            style={ showInput ? {width:width, display:''} : {width} }
                            disabledDate={( currentDate ) =>{ return this.disabledDate(currentDate, "end") }}

                            onChange={(value)=>{this.handleChange(value, options.type, "end")}}
                            renderExtraFooter = {
                                () => {
                                    return (
                                        <div style={{padding : 5}}>
                                            <a className="ant-picker-now-btn"  onClick={this.hithertoDate}  >至今</a>
                                        </div>
                                    )
                                }
                            }
                        />
                        {
                           showInput ? 
                            <>
                                <Input value={inputValue} onClick={this.closeInput} style={{width:width, zIndex:9999, position:'relative', left:`calc(0px - ${width})`}}></Input>
                            </>
                            :<></>
                        }
                        </div>
                        <div className="sf-date-picker-message sm-date-picker-message sg-date-picker-message" style={show!==true ? {display:'none'} : {}}>
                            {message}
                        </div>
                    </div> 
                    : 
                    <div id={divId} >
                        <DatePicker
                            getPopupContainer={()=>document.getElementById(divId)}
                            allowClear={allowClear}
                            defaultValue={defaultValue[0] && dayjs(defaultValue[0], dateFormat)}
                            format={dateFormat}
                            picker={picker}
                            showToday={false}
                            style={{width}}
                            onChange={(value)=>{this.handleChange(value, options.type)}}
                        />
                    </div>
            }
        </div>
    }
}

export default WidgetPositionDate;
